var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchedulerDisable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.7 10",
    style: {
      enableBackground: "new 0 0 18.7 10"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7A7A7A;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.9,0.6c-1.1,0-2,0.4-2.8,1H3.5C1.8,1.6,0.4,3.1,0.4,5s1.4,3.4,3.1,3.4h7.6c0.8,0.6,1.7,1,2.8,1 c2.4,0,4.4-2,4.4-4.4S16.3,0.6,13.9,0.6z M1.4,5c0-1.3,0.9-2.4,2.1-2.4h6.7C9.8,3.3,9.5,4.1,9.5,5s0.3,1.7,0.7,2.4H3.5 C2.3,7.4,1.4,6.3,1.4,5z M16.6,7.3c-0.1,0.2-0.4,0.3-0.6,0.3c-0.2,0-0.4-0.1-0.5-0.2l-1.4-1.3l-1.3,1.4c-0.1,0.2-0.4,0.3-0.6,0.3 c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8-0.1-1.1L13,5l-1.4-1.2c-0.3-0.3-0.3-0.8-0.1-1.1c0.3-0.3,0.8-0.3,1.1-0.1L14,3.9l1.2-1.4 c0.3-0.3,0.8-0.3,1.1-0.1s0.3,0.8,0.1,1.1l-1.2,1.4l1.4,1.3C16.9,6.5,16.9,6.9,16.6,7.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulerDisable);
export default __webpack_public_path__ + "static/media/Scheduler-Disable.88bc7ec3c57066b2704a3512b5f0bb4c.svg";
export { ForwardRef as ReactComponent };